enum InclusionType {
    PART_OF = "part_of",
    INSIDE_OF = "inside_of",
}
  
export default InclusionType;
